// extracted by mini-css-extract-plugin
export default {"container":"bkAsaXfgaINtEaVYMITw","icon":"ymK7SW1oqjHbavWjvZlb","centered":"epZJqbbW9NCnA3Be70Qg","modalBody":"YZM2DnEDMfFJy1uwXa_p","heading":"Yb3TVC4LZqGabjjfltFu"};